const appleRegexs = [
    /iPhone/i,
    /iPod/i
]

const androidRegexs = [
    /Android/i,
    /BlackBerry/i
]

const notSupported = [
    /Windows Phone/i,
    /webOS/i
]

//Add more mobile devices if necessary in 'deviceRegexs'
function testDevice(devicesRegx) {
    const ua = navigator.userAgent
    const testMobileReducer = (acc, current) => acc || ua.match(current)
    const isMobile = devicesRegx.reduce(testMobileReducer, false)
    return isMobile
}

function checkMobileOS() {
    if (testDevice(androidRegexs)) return 'android'
    if (testDevice(appleRegexs)) return 'apple'
    if (testDevice(notSupported)) return 'notSupported'
    return 'default'
}

function isMobile() {
    return testDevice(androidRegexs) || testDevice(appleRegexs)
}

export {
    checkMobileOS,
    isMobile
}



// WEBPACK FOOTER //
// ./src/lib/detectMobile.js